module.exports = __webpack_public_path__ + "static/media/titlecard_customerfeedback@2x.7db32638.jpg";